import gdbx from '@/store/modules/gdbx';
import { addComma } from '@/util/number';
import moment from 'moment';

export interface SplitCurrencyValue {
	__splitCurrency: true;
	symbol: string;
	value: string;
}

export class TableItemFormatter {
	public static basic = (value: number, key?: string, item?: any) =>
		`${addComma(value, gdbx.numDecimal, true)}`

	public static basicInteger = (value: number, key?: string, item?: any) =>
		`${addComma(value, 0, true)}`

	public static basicWithDecimals = (value: number) =>
		`${value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`

	public static currency = (value: number, key?: string, item?: any) =>
		`${gdbx.currencySymbol} ${addComma(Number(value), 0, true)}`

	public static currencyWithDecimals = (value: number, key?: string, item?: any) =>
		`${gdbx.currencySymbol} ${(addComma(Number(value), 2, true))}`

	public static currencySplit = (value: number, key?: string, item?: any): SplitCurrencyValue => ({
		__splitCurrency: true,
		symbol: gdbx.currencySymbol,
		value: addComma(Number(value), 0, true),
	})

	public static currencySplitWithDecimals = (value: number, key?: string, item?: any): SplitCurrencyValue => ({
		__splitCurrency: true,
		symbol: gdbx.currencySymbol,
		value: addComma(Number(value), 2, true),
	})

	public static percentage = (value: number, key?: string, item?: any) =>
		`${addComma(value, gdbx.numDecimal, true)} %`
	public static percentageWithDecimal = (value: number, key?: string, item?: any) =>
		`${value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} %`

	public static date = (value: number, key?: string, item?: any) =>
		`${moment(value).format('DD MMM YYYY')}`
	public static date2 = (value: number, key?: string, item?: any) =>
		`${moment(value).format('MMM YY')}`
	public static date3 = (value: number, key?: string, item?: any) =>
		`${moment(value).format('DD MMM YYYY')}`
	public static date4 = (value: number, key?: string, item?: any) =>
		`${moment(value).format('MMM')}`
	public static dateWithSlashes = (value: number, key?: string, item?: any) =>
		`${moment(value).format('DD/MM/YYYY')}`
}
